import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { applyLogin } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", form);
      applyLogin(data);
      navigate(data.role === "PLATFORM_ADMIN" ? "/admin" : "/profil");
    } catch (e) {
      setError(errMsg(e, "Anmeldung nicht möglich."));
    } finally {
      setBusy(false);
    }
  };


  return (
    <div className="mx-auto max-w-md px-5 py-14">
      <h1 className="text-4xl">Anmelden</h1>
      <p className="mt-2 text-sm text-[var(--ink-soft)]">
        Für Fortschritt, Challenges, Bestätigungen und dein Profil.
      </p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
        <div>
          <div className="eyebrow mb-1">E-Mail</div>
          <input
            className="field"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="login-email"
          />
        </div>
        <div>
          <div className="eyebrow mb-1">Passwort</div>
          <input
            className="field"
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="login-password"
          />
        </div>
        {error ? <p className="text-sm text-red-700" data-testid="login-error">{error}</p> : null}
        <button className="btn btn-primary w-full" disabled={busy} data-testid="login-submit">
          ANMELDEN
        </button>
      </form>
      <p className="mt-6 text-sm text-[var(--ink-soft)]">
        Noch kein Konto?{" "}
        <Link to="/registrieren" className="font-semibold underline" data-testid="login-to-register">
          Registrieren
        </Link>
      </p>
    </div>
  );
}
